import * as React from 'react'
import { useIntl } from 'gatsby-plugin-intl'

const useLocale = () => {
  const intl = useIntl()
  const [locale, setLocale] = React.useState<'en' | 'ja'>(intl.locale)
  React.useEffect(() => {
    const result = intl.locale !== 'en' ? 'ja' : 'en'
    setLocale(result)
  }, [intl])

  return {
    locale: locale,
    isJa: locale === 'ja',
    isEn: locale === 'en',
  }
}

export default useLocale
